/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
//console.log("Hello World! (from mst-galerieblock-slider block)");
/* eslint-enable no-console */

document.addEventListener( 'DOMContentLoaded', () => {
	// Frontend only: gallery thumbnails -> open lightbox, set current slide, continue sliding.
	document.querySelectorAll( '.mst-slider' ).forEach( ( slider ) => {
		let slides = Array.from( slider.querySelectorAll( '.wp-block-image' ) );
		if ( slides.length === 0 ) return;

		let current = 0;
		let interval = null;
		const SPEED_MS = 12000;

		const pauseButton = slider.querySelector( '#pause' );
		const pauseLink = pauseButton ? pauseButton.querySelector( 'a' ) : null;
		const leftButton = slider.querySelector( '#left' );
		const rightButton = slider.querySelector( '#right' );

		function refreshSlides() {
			slides = Array.from( slider.querySelectorAll( '.wp-block-image' ) );
		}

		function setCurrent( index ) {
			refreshSlides();
			if ( slides.length === 0 ) return;

			current = ( ( index % slides.length ) + slides.length ) % slides.length;
			slides.forEach( ( s ) => s.classList.remove( 'showing' ) );
			slides[ current ].classList.add( 'showing' );
		}

		function next() {
			setCurrent( current + 1 );
		}

		function prev() {
			setCurrent( current - 1 );
		}

		function play() {
			if ( interval ) clearInterval( interval );
			interval = setInterval( next, SPEED_MS );
		}

		function stop() {
			if ( interval ) clearInterval( interval );
			interval = null;
		}

		// Small helper to ensure CSS transitions can run when toggling classes.
		function nextFrame( fn ) {
			requestAnimationFrame( () => requestAnimationFrame( fn ) );
		}

		function waitForTransition( el, fallbackMs, done ) {
			let finished = false;
			const finish = () => {
				if ( finished ) return;
				finished = true;
				el.removeEventListener( 'transitionend', onEnd );
				clearTimeout( t );
				done();
			};
			const onEnd = ( e ) => {
				// Only react to transitions on the slider root (not child elements).
				if ( e.target === el ) finish();
			};
			el.addEventListener( 'transitionend', onEnd );
			const t = setTimeout( finish, fallbackMs );
		}

		function openLightboxAt( index ) {
			// Phase 1: mark as transitioning so CSS can animate gallery -> lightbox.
			slider.classList.add( 'lightbox' );
			slider.classList.add( 'mst-lightbox-enter' );
			setCurrent( index );

			// Phase 2: in the next frame, flip to the final state so transitions trigger.
			nextFrame( () => {
				slider.classList.add( 'mst-lightbox-enter-active' );

				// Cleanup transition helper classes after the transition.
				waitForTransition( slider, 450, () => {
					slider.classList.remove( 'mst-lightbox-enter' );
					slider.classList.remove( 'mst-lightbox-enter-active' );
				} );
			} );

			play();
			if ( pauseLink ) {
				//pauseLink.innerHTML = '<span class="dashicons dashicons-fullscreen-exit-alt"></span>';
				pauseLink.innerHTML = '<span class="bi bi-fullscreen-exit"></span>';
			}
		}

		function closeLightbox() {
			// Animate lightbox -> gallery.
			slider.classList.add( 'mst-lightbox-exit' );
			nextFrame( () => {
				slider.classList.add( 'mst-lightbox-exit-active' );
				waitForTransition( slider, 450, () => {
					slider.classList.remove( 'lightbox' );
					slider.classList.remove( 'mst-lightbox-exit' );
					slider.classList.remove( 'mst-lightbox-exit-active' );
				} );
			} );

			stop();
			if ( pauseLink ) {
				//pauseLink.innerHTML = '<span class="dashicons dashicons-fullscreen-alt"></span>';
				pauseLink.innerHTML = '<span class="bi bi-arrows-fullscreen"></span>';
			}
		}

		// Initial state: show first slide so lightbox has a deterministic start.
		setCurrent( 0 );

		// Click on any gallery item: open lightbox at that item and continue sliding from there.
		slides.forEach( ( slide, index ) => {
			slide.addEventListener( 'click', ( e ) => {
				// If the gallery images are linked, prevent navigation.
				e.preventDefault();
				e.stopPropagation();
				openLightboxAt( index );
			} );
		} );

		// Controls
		if ( leftButton ) {
			leftButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				e.stopPropagation();
				if ( slider.classList.contains( 'lightbox' ) ) prev();
			} );
		}

		if ( rightButton ) {
			rightButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				e.stopPropagation();
				if ( slider.classList.contains( 'lightbox' ) ) next();
			} );
		}

		if ( pauseButton ) {
			pauseButton.addEventListener( 'click', ( e ) => {
				e.preventDefault();
				e.stopPropagation();
				if ( slider.classList.contains( 'lightbox' ) ) {
					closeLightbox();
				} else {
					openLightboxAt( current );
				}
			} );
		}
	} );
} );